import React, { useState } from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const GameViewer = ({ onClose, gameComponent }) => {
    const { t } = useTranslation();
    const [isSpectatorMode, setIsSpectatorMode] = useState(false);

    let gameWithProps;

    if (React.isValidElement(gameComponent) && gameComponent.type === React.Suspense) {
        const originalChildren = gameComponent.props.children;
        const clonedChildren = React.isValidElement(originalChildren)
            ? React.cloneElement(originalChildren, { isSpectatorMode })
            : originalChildren;

        gameWithProps = (
            <React.Suspense fallback={gameComponent.props.fallback}>
                {clonedChildren}
            </React.Suspense>
        );
    } else if (React.isValidElement(gameComponent)) {
        gameWithProps = React.cloneElement(gameComponent, { isSpectatorMode });
    } else {
        gameWithProps = gameComponent;
    }

    return (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center animate-fadeIn">
            <div className="relative w-full h-full bg-gray-900 flex flex-col">
                <div className="absolute top-2 right-2 z-10 flex items-center space-x-2">
                    <button
                        onClick={() => setIsSpectatorMode(!isSpectatorMode)}
                        className={`px-3 py-1 text-xs rounded-full flex items-center transition-colors ${isSpectatorMode ? 'bg-purple-600 text-white' : 'bg-gray-700 text-gray-300 hover:bg-gray-600'}`}
                        aria-label={t('gameViewer.toggleSpectatorAriaLabel')}
                    >
                        {isSpectatorMode ? <LucideIcons.User size={14} className="mr-1" /> : <LucideIcons.Bot size={14} className="mr-1" />}
                        {isSpectatorMode ? t('gameViewer.playerControl') : t('gameViewer.spectateAI')}
                    </button>
                    <button
                        onClick={onClose}
                        className="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center text-white hover:bg-red-500 transition-transform transform hover:scale-110"
                        aria-label={t('gameViewer.closeAriaLabel')}
                    >
                        <LucideIcons.X size={20} />
                    </button>
                </div>
                <div className="w-full h-full flex-grow">
                    {gameWithProps}
                </div>
            </div>
        </div>
    );
};

export default GameViewer;
